import React, { FC } from 'react';
import Slide, { SlideProps } from '@mui/material/Slide';

import { Alert } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import Snackbar from '@mui/material/Snackbar';

type TransitionProps = Omit<SlideProps, 'direction'>;

const TransitionDown = (props: TransitionProps) => {
  return <Slide {...props} direction='down' />;
};

export interface ToasterProps {
  isOpen: boolean;
  message: string;
  type: 'success' | 'info' | 'warning' | 'error';
  icon?: React.ReactNode;
  variant?: 'filled' | 'outlined' | 'standard';
  colorOfText?: string;
  closeSnack?: () => void;
  hideDuration?: number;
  id?: string;
}
export const SnackbarPopup: FC<ToasterProps> = ({
  isOpen,
  message,
  type,
  icon,
  variant,
  colorOfText,
  closeSnack,
  hideDuration,
  id,
}) => {
  return (
    <Snackbar
      open={isOpen}
      TransitionComponent={TransitionDown}
      key={TransitionDown ? TransitionDown.name : ''}
      onClose={closeSnack}
      autoHideDuration={hideDuration ? hideDuration : type !== 'error' ? 4000 : 8000}
      sx={{ width: 'fit-content' }}
    >
      <Alert
        variant={variant ?? 'filled'}
        severity={type}
        color={type}
        icon={icon || ''}
        sx={{ alignItems: 'center', color: colorOfText }}
        id={id || 'toast-message'}
      >
        {isOpen && (
          <FormattedMessage id={message || 'Error'} defaultMessage={message || 'Error'} />
        )}
      </Alert>
    </Snackbar>
  );
};
